import { memo } from 'react';
import { IconWrapper } from 'src/modules/common/icons/IconWrapper.tsx';

export const WarningIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                // eslint-disable-next-line
                d="M4.546 19.7a.719.719 0 0 1-.646-.375.684.684 0 0 1-.004-.75l7.458-12.85a.761.761 0 0 1 .284-.288A.752.752 0 0 1 12 5.35c.133 0 .254.029.363.087a.761.761 0 0 1 .283.288l7.458 12.849a.684.684 0 0 1-.004.75.72.72 0 0 1-.646.375H4.546ZM12 17.5c.142 0 .26-.048.356-.144A.484.484 0 0 0 12.5 17a.484.484 0 0 0-.144-.357A.484.484 0 0 0 12 16.5a.483.483 0 0 0-.356.143.483.483 0 0 0-.144.357c0 .141.048.26.144.356A.484.484 0 0 0 12 17.5Zm.001-2a.34.34 0 0 0 .349-.35v-4.3c0-.1-.034-.183-.101-.25a.34.34 0 0 0-.25-.1.339.339 0 0 0-.349.35v4.3c0 .099.034.182.101.25.067.066.15.1.25.1Z"
            />
        </svg>
    </IconWrapper>
));
